import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  filterBox: false,
  propertiesReset: false,
  propertyTopData: {
    address: "",
    price: "",
    id: "",
  },
};

export const propertieSlice = createSlice({
  name: "propertie",
  initialState,
  reducers: {
    // setAnswerValue: (state, actions: PayloadAction<ISetAnswerValue>) => {
    //   state.answerSubmitValue = actions.payload.data
    // },
    setFilterBox: (state) => {
      state.filterBox = !state.filterBox;
      rootCssSet();
    },
    setInvitesListReset: (state) => {
      state.propertiesReset = !state.propertiesReset;
    },

    setPropertyTopData: (state, action) => {
      state.propertyTopData = action?.payload;
    },
  },
});

export const propertieAction = propertieSlice.actions;
export const propertieReducer = propertieSlice.reducer;
